import { pick, reduce } from "lodash";
import { useInjection } from "@linkfluence/core/di";
import { useQuery } from "@tanstack/react-query";
import { PLATFORMS } from "@radarly/models/insight-pages/wizard/model/account";
import { CorporaRepo, CorporaRepositoryUID } from "../repositories/CorporaRepo";

export function useCorporaTotalSourcesByPlatform(project: number) {
  const repository = useInjection<CorporaRepo>(CorporaRepositoryUID);
  const { data, isLoading, isError } = useQuery(
    ["/corpora-total-sources-by-platform/get", { project }],
    () => {
      return repository.getCorporaTotalSourcesByPlatform(project);
    }
  );
  return {
    totalCorpusesSources: reduce(
      data,
      (acc, corpus, id) => {
        //@ts-ignore
        acc[id] = pick(corpus, PLATFORMS.concat(["web"]));
        return acc;
      },
      {}
    ),
    loading: isLoading,
    error: isError,
  };
}
